import { Field, ID, InputType } from 'type-graphql'
import { Customer } from '../../customer/Customer'
import { ActionArgs } from '../../action/ActionArgs'

@InputType()
export class CloneOrderArgs extends ActionArgs {
  @Field(() => ID)
  _id: string

  @Field(() => Customer)
  by: { _id: string }

  @Field(() => Boolean)
  discount: boolean

  @Field(() => Boolean)
  taxAmount: boolean

  @Field(() => Boolean)
  shippingFee: boolean

  @Field(() => Boolean)
  customerPoNumber: boolean

  @Field(() => Boolean)
  allowPrePayment: boolean

  @Field(() => Boolean)
  members: boolean

  @Field(() => Boolean)
  communication: boolean
}
